<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Omnia Theme</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation">
            Edit
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <el-tabs v-model="activeTabName">
        <el-tab-pane name="general" label="General">
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="editForm.name" placeholder="Name" readonly>
                <template slot="prefix">Name</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="editForm.themeFolder"
                readonly
                placeholder="Enter theme folder"
              >
                <template slot="prefix">Omnia theme folder</template>
              </el-input>
            </el-col>
          </div>

          <div class="inline-form-group">
            <el-col :span="12">
              <dads-select
                v-model="editForm.partnerId"
                placeholder="Select partner account"
                v-if="!isPartnerAdmin"
              >
                <template slot="prefix">Partner</template>
                <el-option
                  v-for="(partner, index) in partnerOptions"
                  :label="partner.name"
                  :key="index"
                  :value="partner.id"
                />
              </dads-select>
            </el-col>
          </div>

          <h2 class="form-section-header">
            Omnia application urls
          </h2>
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="editForm.appDomain" placeholder="App url">
                <template slot="prefix">App url</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="editForm.meetDomain"
                placeholder="Meet domain"
              >
                <template slot="prefix">Meet domain</template>
              </el-input>
            </el-col>
          </div>
          <el-input
            v-model="editForm.quickDialUrl"
            placeholder="Quick dial extension url"
          >
            <template slot="prefix">Quick dial extension url</template>
          </el-input>

          <h2 class="form-section-header">
            Mobile application
          </h2>
          <div class="inline-form-group">
            <el-col :span="11">
              <el-input
                v-model="editForm.csName"
                placeholder="Mobile app identifier"
              >
                <template slot="prefix">Mobile app identifier</template>
              </el-input>
            </el-col>
          </div>
          <el-input v-model="editForm.iosUrl" placeholder="IOS app url">
            <template slot="prefix">IOS app url</template>
          </el-input>
          <el-input
            v-model="editForm.androidUrl"
            placeholder="Android app url"
          >
            <template slot="prefix">Android app url</template>
          </el-input>

          <h2 class="form-section-header">
            Support details
          </h2>

          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                v-model="editForm.supportUrl"
                placeholder="Support website url"
              >
                <template slot="prefix">Support website url</template>
              </el-input>
            </el-col>
            <el-col :span="1"/>
            <el-col :span="11">
              <el-input
                v-model="editForm.supportEmail"
                placeholder="Support email"
              >
                <template slot="prefix">Support email</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                v-model="editForm.changelogURL"
                placeholder="Change log url"
              >
                <template slot="prefix">Change log url</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input v-model="editForm.website" placeholder="Company website url">
                <template slot="prefix">Company website url</template>
              </el-input>
            </el-col>
          </div>

          <h2 class="form-section-header">
            Emails and social
          </h2>

          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="editForm.infoEmail" placeholder="Info email">
                <template slot="prefix">Info email</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="editForm.senderEmail"
                placeholder="Sender email"
              >
                <template slot="prefix">Sender email</template>
              </el-input>
            </el-col>
          </div>

          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                v-model="editForm.meetSenderEmail"
                placeholder="Meet Sender email"
              >
                <template slot="prefix">Meet Sender email</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="editForm.twitterHandle"
                placeholder="Twitter handle"
              >
                <template slot="prefix">Twitter handle</template>
              </el-input>
            </el-col>
          </div>
        </el-tab-pane>
        <el-tab-pane name="images" label="Images">
          <omnia-image-uploader
            title="App logo url (light mode)"
            :previewURL="editForm.logoUrl"
            :file="appLogoLightFile"
            @onUpload="appLogoLightFile = $event"
            @clearUpload="clearAppLogoLightUpload"
          />
          <omnia-image-uploader
            title="App logo url (dark mode)"
            :previewURL="editForm.logoLightUrl"
            :file="appLogoDarkFile"
            @onUpload="appLogoDarkFile = $event"
            @clearUpload="clearAppLogoDarkUpload"
          />
          <omnia-image-uploader
            title="Logo icon"
            :previewURL="editForm.logoOnlyUrl"
            :file="logoIconFile"
            @onUpload="logoIconFile = $event"
            @clearUpload="clearLogoIconUpload"
          />
          <omnia-image-uploader
            title="Favicon"
            :file="faviconFile"
            :previewURL="faviconURL"
            @onUpload="faviconFile = $event"
            @clearUpload="clearFaviconUpload"
          />
          <omnia-image-uploader
            title="Preview image"
            :file="previewImageFile"
            :previewURL="previewURL"
            @onUpload="previewImageFile = $event"
            @clearUpload="clearPreviewImageUpload"
          />
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
import omniaImageUploader from "./omniaImageUploader.vue";
import DadsSelect from '@/components/select';

export default {
  name: "OmniaThemeEditForm",

  props: {
    editVisible: { required: true },
    clearFormFields: { required: true },
    editProcessing: { required: true },
    selectedOmniaTheme: { required: true },
    partnerOptions: { required: true }
  },

  components: { omniaImageUploader, DadsSelect },

  data() {
    return {
      activeTabName: "general",
      editForm: {
        name: "",
        appDomain: "",
        meetDomain: "",
        supportUrl: "",
        infoEmail: "",
        supportEmail: "",
        senderEmail: "",
        website: "",
        iosUrl: "",
        androidUrl: "",
        themeFolder: "",
        twitterHandle: "",
        quickDialUrl: "",
        csName: "",
        changelogURL: "",
        approved: false,
        logoUrl: "",
        logoLightUrl: "",
        logoOnlyUrl: "",
        partnerId: "",
        meetSenderEmail: ""
      },
      // ⭐️ Image Uploads ⭐️ //
      faviconURL: "",
      previewURL: "",
      imageFileNames: [
        "appLogoLightFile",
        "appLogoDarkFile",
        "logoIconFile",
        "faviconFile",
        "previewImageFile"
      ],
      appLogoLightFile: null,
      appLogoDarkFile: null,
      logoIconFile: null,
      faviconFile: null,
      previewImageFile: null
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedOmniaTheme(val) {
      if (val) {
        Object.keys(val).forEach(key => {
          if (key in this.editForm) {
            this.editForm[key] = val[key];
          }
        });
      }
      this.editForm.approved = val.approved === 1;
      this.faviconURL = val.faviconURL;
      this.previewURL = val.previewURL;
    }
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    isPartnerAdmin() {
      if (this.user) {
        return +this.user.userRole === 11;
      }
    }
  },

  methods: {
    clearAppLogoLightUpload() {
      this.appLogoLightFile = null;
      this.editForm.logoUrl = "";
    },

    clearAppLogoDarkUpload() {
      this.appLogoDarkFile = null;
      this.editForm.logoLightUrl = "";
    },

    clearLogoIconUpload() {
      this.logoIconFile = null;
      this.editForm.logoOnlyUrl = "";
    },

    clearFaviconUpload() {
      this.faviconFile = null;
      this.faviconURL = "";
    },

    clearPreviewImageUpload() {
      this.previewImageFile = null;
      this.previewURL = "";
    },

    editOperation() {
      const formData = new FormData();
      Object.keys(this.editForm).forEach(key => {
        if (typeof this.editForm[key] === "string"  || typeof this.editForm[key] === "number") {
          formData.append(key, this.editForm[key]);
        }

        if (typeof this.editForm[key] === "boolean") {
          formData.append(key, this.editForm[key] ? 1 : 0);
        }
      });

      this.imageFileNames.forEach(fileName => {
        if (this[fileName]) {
          formData.append(fileName.replace("File", ""), this[fileName].raw);
        }
      });

      ["name", "appDomain"].forEach(field => {
        if (this.editForm[field] === this.selectedOmniaTheme[field]) {
          formData.delete(field);
        }
      });

      this.$emit("editOperation", formData);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.activeTabName = "general";
      this.faviconURL = "";
      this.previewURL = "";
      this.imageFileNames.forEach(fileName => {
        this[fileName] = null;
      });
      Object.keys(this.editForm).forEach(key => {
        if (typeof this.editForm[key] === "string") {
          this.editForm[key] = "";
        }

        if (typeof this.editForm[key] === "boolean") {
          this.editForm[key] = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tabs {
  max-width: 600px;
  margin: 0 auto;
}

.el-checkbox {
  max-width: 600px;
  margin: 0 auto;
}
</style>
